// dependencies
import { useEffect, useState } from "react";

import Rich from "../../assets/images/recommendation-rich-freeman.jpg"
import Scott from "../../assets/images/recommendation-scott-mccrindle.jpg"
import Walsh from "../../assets/images/recommendation-scott-walsh.jpg"
import Randolph from "../../assets/images/recommendation-randolph-burlton.jpg"
import Vitalii from "../../assets/images/recommendation-vitalii-romanov.jpg"

function Recommendation() {
    let [currentIndex, setCurrentIndex] = useState(0);
    let [contents, setContents] = useState([
        {
            quote: `"Jihan did great work translating complex web features into intuitive mobile experiences for the Canadian Tire app, with a strong grasp of iOS guidelines, usability best practices, and accessibility. She collaborated closely with Product, UI, and Engineering partners, built context quickly across teams, and was thoughtful in how she presented and documented her work. Jihan brings a strong product mindset, is easy to work with, and would be a great addition to any product team. I'd happily recommend her!"`,
            citation: "Scott Walsh",
            link: "https://www.linkedin.com/in/scott-w-321b6b75/",
            position: "Lead Product Designer at Canadian Tire",
            picture: Walsh
        },
        {
            quote: `"Jihan turned a short contract into an indispensable 8-month tenure. She was vital to our Web-to-App initiative, notably stepping up to manage the squad solo and handling stakeholder alignment with confidence. She also left a lasting mark on our operations by creating our internal competitive research repository, leading it from scratch and presenting it at our department-wide Digital Showcase… Jihan is a proactive designer who leaves a team better than she found it."`,
            citation: "Randolph Burlton",
            link: "https://www.linkedin.com/in/randolphburlton/",
            position: "UX Design Manager at Canadian Tire",
            picture: Randolph
        },
        {
            quote: `"I highly recommend Jihan as a designer. She delivered beautiful, high-quality designs that were always clear, thoughtful, and required no revisions. Her mockups were technically excellent and very easy to work with. Jihan is also a pleasure to collaborate with on a personal level — kind, friendly, positive, and efficient. Communication with her was smooth, and the overall workflow was fast and effective. I would be happy to work with her again anytime."`,
            citation: "Vitalii Romanov",
            link: "https://www.linkedin.com/in/vitalii-romanov-85273057/",
            position: "Lead Software Engineer at Canadian Tire",
            picture: Vitalii
        },
        {
            quote: `"Jihan is an extremely talented individual, combining extensive design experience with solid front and back-end web development skills. She's thoughtful and diligent, while also displaying outstanding collaboration skills. Jihan is bright, engaging, and consistently produces high-quality work. I recommend her without reservation as a welcome addition to any team."`,
            citation: "Rich Freeman",
            link: "https://ca.linkedin.com/in/rich-freeman",
            position: "Professor at Georgian College",
            picture: Rich
        },
        {
            quote: `"It is awesome to watch Jihan combine her natural creative and technical ability with her impressive knowledge of various Web technology stacks. Her vibrant personality and her unwavering commitment to quality and innovation will make her an indispensable team member. Jihan is an all-star!"`,
            citation: "Scott McCrindle",
            link: "https://ca.linkedin.com/in/scottmccrindle",
            position: "Professor at Georgian College",
            picture: Scott
        }
    ]);

    useEffect(() => {
        let carousel = document.querySelector('.reco-carousel');
        if (carousel) {
            let carouselContents = carousel.querySelectorAll('.carousel-content');
            if (carouselContents.length > 0) {
                setContents(Array.from(carouselContents).map(content => ({
                    quote: content.querySelector('p').innerText,
                    citation: content.querySelector('figcaption a').innerText,
                    link: content.querySelector('figcaption a').getAttribute('href'),
                    position: content.querySelector('figcaption p:last-of-type').innerText,
                    picture: content.querySelector('figure img').getAttribute('src')
                })));
            }
        }
    }, []);

    let handlePrevClick = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + contents.length) % contents.length);
    };

    let handleNextClick = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % contents.length);
    };

    return (
        <section className="about-content">
            <h3>Recommendations</h3>
            <div className="reco-carousel">
                <div className="carousel-container">
                    {contents.map((content, index) => (
                        <div className={`carousel-content ${index === currentIndex ? 'active-content' : ''}`} key={index}>
                            <blockquote>
                                <p>{content.quote}</p>
                                <figure>
                                <a href={content.link}><img src={content.picture} alt={`${content.citation}`} /></a>
                                    <figcaption>
                                        <a href={content.link}>{content.citation}</a>
                                        <p>{content.position}</p>
                                    </figcaption>
                                </figure>
                            </blockquote>
                        </div>
                    ))}
                </div>
                <div className="carousel-arrows">
                    <button type="button" className="arrow arrow-prev" onClick={handlePrevClick}>
                        <i className="bi bi-arrow-left"></i>
                    </button>
                    <button type="button" className="arrow arrow-next" onClick={handleNextClick}>
                        <i className="bi bi-arrow-right"></i>
                    </button>
                </div>
            </div>
        </section>
    );
};

export default Recommendation;